export default __webpack_public_path__ + "static/media/BGVideo.2ef31df9.mp4";